import { apiClientAuth } from "../http/httpClient";


export function FileApi(contentType = "application/json")
{
    const https = apiClientAuth(contentType);

    
    return {


        insert : (folderId, data) => https.post(`/api/file/${folderId}`, data),

        updateOne : (id, data) => https.put(`/api/file/${id}`, data),

        findPublicOnes: () => https.get(`/api/file/public`),

        findAllByFolder: ( folderId ) => https.get(`/api/file/folder/${folderId}`),

        findOne: (id) => https.get(`/api/file/${id}`),

        deleteOne: (id) => https.delete(`/api/file/${id}`)

        
    };
}
